import { ActionReducerMapBuilder } from '@reduxjs/toolkit';

import _ from 'lodash';

import * as actions from '../actions';
import { PubnubState } from '..';

export const getRaiseHandMsgsBuilder = (builder: ActionReducerMapBuilder<PubnubState>) => {
  return builder
    .addCase(actions.getRaiseHandMessages.pending, (state) => {
      state.isBusy = true;
    })
    .addCase(actions.getRaiseHandMessages.fulfilled, (state, action) => {
      const reversedMessages = _.reverse(action.payload);

      if (action.payload) state.raiseHand.messages = [...state.raiseHand.messages, ...reversedMessages];
      state.isBusy = false;
    })
    .addCase(actions.getRaiseHandMessages.rejected, (state) => {
      state.isBusy = false;
    });
};

export const getRaiseHandMsgsCountBuilder = (builder: ActionReducerMapBuilder<PubnubState>) => {
  return builder
    .addCase(actions.getRaiseHandMessagesCount.pending, (state) => {
      state.isBusy = true;
    })
    .addCase(actions.getRaiseHandMessagesCount.rejected, (state) => {
      state.isBusy = false;
    })
    .addCase(actions.getRaiseHandMessagesCount.fulfilled, (state, action) => {
      const newData = Object.values(action.payload)[0] || 0;

      state.raiseHand.total = newData;
      state.isBusy = false;
    });
};

export const checkUserRaiseHandMsgBuilder = (builder: ActionReducerMapBuilder<PubnubState>) => {
  return builder.addCase(actions.checkUserRaiseHandMsg.fulfilled, (state, action) => {
    if (!action.payload.messageTT) {
      state.currentRaiseHandMsgTT = null;
    }

    state.isBusy = false;
  });
};
